import { createSlice } from '@reduxjs/toolkit';
import { IMPERSONATION_INFO } from '../data/constants';

interface ImpersonationState {
    isImpersonating: boolean;
}

const initialState: ImpersonationState = {
    isImpersonating: localStorage.getItem(IMPERSONATION_INFO.IsImpersonating) === "true",
};

const impersonationSlice = createSlice({
    name: 'impersonation',
    initialState,
    reducers: {
        startImpersonation(state) {
            state.isImpersonating = true;
        },
        stopImpersonation(state) {
            state.isImpersonating = false;
        },
    },
});

export const { startImpersonation, stopImpersonation } = impersonationSlice.actions;
export default impersonationSlice.reducer;
